import { range } from 'lodash';

interface BreakLineProps {
  /**
   * The number of `<br />` to add.
   */
  n?: number;
}
/**
 * Utitlity component to quickly insert breaklines
 * upto `n`.
 */
export const BreakLine = ({ n = 1 }: BreakLineProps) => (
  <>
    {range(0, n).map(v => (
      <br key={v} />
    ))}
  </>
);

/**
 * Utitlity component to quickly insert breaklines
 * upto `n`.
 */
export const Br = BreakLine;
